import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const COLORS = ['#F39C12', '#2C3E50', '#27AE60', '#E74C3C', '#8E44AD', '#2980B9', '#E67E22', '#1ABC9C'];

const LeadSourceChart = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-muted-foreground text-sm">
        No source data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={240}>
      <PieChart>
        <Pie data={data} cx="50%" cy="50%" outerRadius={80} dataKey="value" nameKey="name" label={({ name, percent }) => `${name} ${(percent * 100)?.toFixed(0)}%`} labelLine={false}>
          {data?.map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
          ))}
        </Pie>
        <Tooltip formatter={(value) => [value, 'Prospects']} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default LeadSourceChart;
